import { Component, ViewChild, ElementRef, Input } from '@angular/core';

import { AbstractComponent } from 'src/core/common/component/AbstractComponent';

import { GSCaptureMultiService } from './GSCaptureMultiService';

import Hls from "hls.js";

@Component({
  selector: 'gs-capture-multi',
  templateUrl: './GSCaptureMulti.html',
  styleUrls: ['./GSCaptureMulti.scss']
})
export class GSCaptureMultiComponent extends AbstractComponent {

  @Input('id')
  public id: any;

  @Input('name')
  public name: any;

  @ViewChild('videoPlayer') 
  public videoPlayer: ElementRef;

  public interval;

  public loading = true;

  public constructor(private service:GSCaptureMultiService,
                     private el: ElementRef) {
    super();
  }

  public componentWillMount() {

    this.service.getStream(this.id).subscribe((video:any) => {
      this.loadSource(video.url.HLSStreamingSessionURL).then(() => {

      });
    });
  }

  // GSVideoComponentから拝借。任意のストリーミング動画（url）の読み込み。
  public loadSource(url) {
    return new Promise((resolve) => {

      if (this.interval) {
        clearInterval(this.interval);
      }

      let video = this.videoPlayer.nativeElement;
      const hls = new Hls();
      hls.loadSource(url);
      hls.attachMedia(video);
      
      this.loading = false;

      hls.on(Hls.Events.MEDIA_ATTACHED, () => {

        video.style.display = "block";
        video.muted = true;
        video.play();
        hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {});

        setTimeout(() => {
          resolve(true);
        }, 100);

      });
    });
  }
}
